import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import { CompletedImg } from '~/img';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import theme from '~/constants/theme';

const SuccessfulOnboarding: FC = () => {
  const { t } = useTranslation('stageResult');

  return (
    <WizardContent
      content={
        <Container className="SuccessfulOnboarding">
          <div className="SuccessfulOnboarding-Content">
            <CompletedImg className="SuccessfulOnboarding-Img" />
            <Typography.Title className="SuccessfulOnboarding-Title">{t('Application approved!')}</Typography.Title>
            <Typography.Paragraph className="SuccessfulOnboarding-Paragraph">
              <p>{t('Welcome to the Network family.')}</p>
              <p>
                {t(
                  'We will soon be sending you our welcome kit which will explain the next steps to enable you to start taking payments.',
                )}
              </p>
              {/* <p>
                <Trans t={t} i18nKey="In the meantime, if you wish to speak to us, please <1>contact us</1>.">
                  {'In the meantime, if you wish to speak to us, please '}
                  <a href={features.contactUsLink} target="__blank">
                    contact us
                  </a>
                  .
                </Trans>
              </p> */}
            </Typography.Paragraph>
          </div>
          <div className="SuccessfulOnboarding-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLink} contactUsTextPosition="left" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .SuccessfulOnboarding-Content {
    position: relative;
    .SuccessfulOnboarding-Img {
      width: 100%;
      margin-bottom: 32px;
    }
    .SuccessfulOnboarding-Title {
      position: absolute;
      top: 25%;
      left: 5%;
      width: 30%;
    }
    .SuccessfulOnboarding-Paragraph {
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .SuccessfulOnboarding-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SuccessfulOnboarding-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SuccessfulOnboarding-Paragraph {
        margin-left: 0;
      }
    }
  }
  .SuccessfulOnboarding-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .SuccessfulOnboarding-ContactUs {
      display: none;
    }
  }
`;

export default SuccessfulOnboarding;
